<template>
	<el-container class="home" @click.native="show1=false">
		<el-header class="header">
			<div style="display: flex;align-items: center;justify-content: center;width: 200px;position: relative;">
				<img src="http://quanlang.top/static/img/indexlogo.png"
					style="width: 160px;height: 50px;z-index: 9999;">
				<div :Class="tClass"></div>
			</div>

			<div class="icon" @click="changeShow">
				<i :class="show?'el-icon-s-fold':'el-icon-s-unfold'" style="cursor:pointer;"></i>
			</div>
			<div class="top-right">
				<span>欢迎你,{{user.ali_real_name||'-'}}</span>
				<div style="position: relative;">
					<span class="el-icon-message" style="margin: 0 30px;font-size: 20px;cursor:pointer;"
						@click.stop="show1=!show1"></span>
					<el-collapse-transition>
						<NoticeList v-show="show1"></NoticeList>
					</el-collapse-transition>
					<div v-if="user.not_read_notice_num>0"
						style="width: 15px;height: 15px;border-radius: 50%;background-color: #F56C6C;top:-3px;right:20px;position: absolute;display: flex;align-items: center;justify-content: center;">
						<span
							style="font-size: 12px;color: #fff;transform: scale(0.8);">{{user.not_read_notice_num}}</span>
					</div>
				</div>
				<el-popover placement="top" width="240" trigger="hover">
					<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
						<span style="font-size: 13px;color: #959595;">
							群号 105047820
						</span>
						<canvas id="qrcode1"></canvas>
						<el-link type="primary" @click="join">点击加入群聊【权朗网络】</el-link>
					</div>
				
					<div class="scan2" slot="reference">
						<img src="../assets/qq.png" style="width: 20px;height: 20px;">
					</div>
				</el-popover>
				<div style="display: flex;align-items: center;cursor:pointer;" @click="logout">
					<img src="../assets/out.png" style="width: 16px;height: 16px;">
					<span style="margin-left: 5px;">退出</span>
				</div>
			</div>
		</el-header>
		<el-container>
			<el-aside width="230px" :class="showClass" class="left"
				style="background-color:rgb(31, 34, 36);border-right: 1px solid rgb(58, 65, 68);">
				<div class="info">
					<img src="../assets/avatar.jpg"
						style="width: 86px;height: 86px;border-radius: 50%;margin-bottom: 10px;">
					<span>{{user.ali_real_name||'-'}}</span>
					<span>ID:{{user.center_id||'-'}}</span>
				</div>
				<div style="flex: 1;background-color: rgb(40, 45, 47);">
					<div class="cbox" :style="'height:'+leftHeight+'px'">
						<div class="menu-grid">
							<div
								v-for="(item,index) in menus"
								:key="index"
								class="menu-card"
								:class="[{active:defaultActive===item.path}, item.path==='/index' ? 'menu-card-home' : '']"
								@click="goMenu(item.path)">
								<i :class="item.icon"></i>
								<span>{{item.title}}</span>
							</div>
						</div>
					</div>
				</div>

			</el-aside>
			<el-main style="position: relative;background-color: rgb(58, 65, 68);">
				<router-view></router-view>
			</el-main>
		</el-container>
		<el-popover placement="top" width="100" trigger="hover">
			<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<canvas id="qrcode"></canvas>
				<span style="font-size: 13px;color: #959595;">
					扫描二维码下载权朗App
				</span>
			</div>

			<div class="scan" slot="reference">
				<img src="../assets/scan.png" style="width: 35px;height: 35px;">
			</div>
		</el-popover>
		
	</el-container>
</template>

<script>
	import QRCode from 'qrcode'
	// @ is an alias to /src
	import {
		mapState
	} from 'vuex'
	import NoticeList from '../components/notice/NoticeList.vue'
	export default {
		name: 'HomeView',
		components: {
			NoticeList
		},

		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch: {
			'$route'(to, from) {
				if (to.path) {
					this.defaultActive = to.path
				}
				if (this.user) {
					this.checkToken()
				}
			},
		},
		data() {
			return {
				leftHeight: 0,
				show: false,
				visible: false,
				showClass: '',
				tClass: '',
				show: true,
				show1: false,
				defaultActive: '/index',
				menus: [{
						title: '首页',
						path: "/index",
						icon: 'el-icon-s-home',
						index: '1'
					}, {
						title: '卡密',
						path: "/card",
						icon: 'el-icon-bank-card',
						index: '2'
					}, {
						title: '软件',
						path: "/software",
						icon: 'el-icon-mobile-phone',
						index: '3'
					}, {
						title: '帮助',
						path: "/help",
						icon: 'el-icon-warning-outline',
						index: '4'
					}, {
						title: '文件',
						path: "/file",
						icon: 'el-icon-document',
						index: '5'
					}, {
						title: '用户',
						path: "/user",
						icon: 'el-icon-s-custom',
						index: '6'
					}, {
						title: '充值',
						path: "/charge",
						icon: 'el-icon-bank-card',
						index: '7'
					}, {
						title: '代理',
						path: "/agent",
						icon: 'el-icon-coordinate',
						index: '8'
					}, {
						title: '数据',
						path: "/data",
						icon: 'el-icon-s-data',
						index: '9'
					}, {
						title: '日志',
						path: "/log",
						icon: 'el-icon-notebook-2',
						index: '10'
					}, {
						title: '消息',
						path: "/msg",
						icon: 'el-icon-chat-line-round',
						index: '11'
					}, {
						title: '推广',
						path: "/promotion",
						icon: 'el-icon-receiving',
						index: '12'
					}, {
						title: '设置',
						path: "/setting",
						icon: 'el-icon-setting',
						index: '13'
					}, {
						title: '实名',
						path: "/authentication",
						icon: 'el-icon-user',
						index: '14'
					}, {
						title: '售卡',
						path: "/sell_log",
						icon: 'el-icon-s-shop',
						index: '15'
					}, {
						title: '提现',
						path: "/cash",
						icon: 'el-icon-money',
						index: '16'
					}, {
						title: '统计',
						path: "/sell_count",
						icon: 'el-icon-coin',
						index: '17'
					}
				]
			}
		},
		created() {
			let {
				path
			} = this.$route
			console.log(path)
			if (path) {
				this.defaultActive = path
			}
			this.checkToken()
		},
		mounted() {
			window.addEventListener('resize', this.handleResize)
			this.handleResize()
			this.showScan()
			this.showScan1()
		},
		methods: {
			join(){
				window.open('http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=7o36sheUpnxzMsgr9sXZjcZV_fo-5GiX&authKey=efl6d1jtnRv4aSI3LpkBHNOOWJqU0mxXKI24ZHWcE%2Buae0BKOG1qlBxalkdyKRP0&noverify=0&group_code=105047820')
			},
			selectData(index) {
				if (index === this.$route.path) {
					this.$store.dispatch('setReload',!this.reload)
				}
			},
			goMenu(path) {
				if (path === this.$route.path) {
					this.$store.dispatch('setReload',!this.reload)
					return
				}
				this.$router.push({
					path
				})
			},
			handleResize() {
				this.leftHeight = window.innerHeight - 280
			},
			showScan() {
				let canvas = document.getElementById("qrcode")
				let opts = {
					errorCorrectionLevel: 'H',
					type: "image/png",
					quality: 0.3,
					margin: 0,
					width: 200,
					height: 200,
					text: 'http://wz4.cc/app',
					color: {
						dark: '#333',
						light: '#fff'
					}

				}
				QRCode.toCanvas(canvas, 'http://wz4.cc/app', (err) => {
					console.log(err)
				})
			},
			showScan1() {
				let canvas = document.getElementById("qrcode1")
				let opts = {
					errorCorrectionLevel: 'H',
					type: "image/png",
					quality: 0.3,
					margin: 0,
					width: 200,
					height: 200,
					text: 'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=7o36sheUpnxzMsgr9sXZjcZV_fo-5GiX&authKey=efl6d1jtnRv4aSI3LpkBHNOOWJqU0mxXKI24ZHWcE%2Buae0BKOG1qlBxalkdyKRP0&noverify=0&group_code=105047820',
					color: {
						dark: '#333',
						light: '#fff'
					}
			
				}
				QRCode.toCanvas(canvas, 'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=7o36sheUpnxzMsgr9sXZjcZV_fo-5GiX&authKey=efl6d1jtnRv4aSI3LpkBHNOOWJqU0mxXKI24ZHWcE%2Buae0BKOG1qlBxalkdyKRP0&noverify=0&group_code=105047820', (err) => {
					console.log(err)
				})
			},
			changeShow() {
				if (this.show == true) {
					this.showClass = 'contain close'
					this.tClass = "top-box"
					this.show = false
				} else {
					this.showClass = 'contain'
					this.tClass = "top-box close"
					this.show = true
				}
			},

			logout() {
				this.$store.dispatch('logout').then(() => {
					this.$message.success('退出登录成功')
					this.$router.push({
						name: 'login'
					})
				})
			},
			checkToken() {
				this.$H.post('/quanlang/v1_0_1.Index/CheckToken', {}).then(res => {
					console.log(res)
				})
			},

		}
	}
</script>

<style>
	.el-menu-item.is-active {
		background-color: #1f2224 !important;
	}

	.cbox {
		overflow-y: auto;
		scrollbar-face-color: #fff;
	}

	.cbox::-webkit-scrollbar-track {
		background-color: #f5f5f5;
	}

	.cbox::-webkit-scrollbar-thumb {
		background-color: #fff;
		border-radius: 10px;
	}

	.home {
		width: 100%;
		display: flex;
		position: relative;
	}

	.home .header {
		height: 65px;
		display: flex;
		align-items: center;
		padding: 0 20px;
	}

	.home .icon {
		width: 65px;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 30px;
		border-right: 1px solid #282d2f;
		color: #fff;
	}

	.left {
		display: flex;
		flex-direction: column;
	}

	.left .info {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 10px;
	}

	.left .info span {
		font-size: 15px;
		color: #cfcfcf;
		margin-top: 5px;
	}

	.top-right {
		margin-left: auto;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #cfcfcf;
	}

	.contain {
		width: 360px;
		overflow: hidden;
		animation: fold .8s ease-in-out forwards;
	}

	.contain.close {
		width: 0px;
		animation: unfold .8s ease-in-out forwards;
	}

	@keyframes fold {
		from {
			width: 0px;
		}

		to {
			width: 360px;
		}
	}

	@keyframes unfold {
		from {
			width: 360px;
		}

		to {
			width: 0px;
		}
	}

	.top-box {
		position: absolute;
		top: -5px;
		bottom: -5px;
		left: -20px;
		width: 0px;
		background-color: rgb(31, 34, 36);
		overflow: hidden;
		animation: lines .8s ease-in-out forwards;
	}

	.top-box.close {
		width: 0px;
		animation: ulines .8s ease-in-out forwards;
	}

	@keyframes lines {
		from {
			width: 0px;
		}

		to {
			width: 360px;
		}
	}

	@keyframes ulines {
		from {
			width: 360px;
		}

		to {
			width: 0px;
		}
	}

	.menu-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		padding: 8px;
	}

	.menu-card {
		height: 47px;
		display: flex;
		align-items: center;
		padding: 0 18px;
		box-sizing: border-box;
		border: 1px solid #3f4649;
		color: #aab0b0;
		font-size: 18px;
		background-color: #1f2224;
		cursor: pointer;
		transition: color .2s ease, border-color .2s ease;
	}

	.menu-card i {
		font-size: 15px;
		margin-right: 10px;
	}

	.menu-card span {
		font-size: 14px;
	}

	.menu-card:hover,
	.menu-card.active {
		color: #fff;
		border-color: #697278;
	}

	.menu-card-home {
		grid-column: 1 / -1;
		justify-content: center;
	}

	.scan {
		width: 50px;
		height: 50px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 1px;
		position: absolute;
		bottom: 30px;
		right: 30px;
		background-color: rgb(122, 122, 122);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		box-shadow: 0 15px 30px rgba(255, 255, 255, .2);
		-webkit-animation-name: scaleDraw;
		/*关键帧名称*/
		-webkit-animation-timing-function: ease-in-out;
		/*动画的速度曲线*/
		-webkit-animation-iteration-count: infinite;
		/*动画播放的次数*/
		-webkit-animation-duration: 4s;
		/*动画所花费的时间*/
	}

	@keyframes scaleDraw {

		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			transform: scale(1);
			/*开始为原始大小*/
		}

		25% {
			transform: scale(1.2);
			/*放大1.1倍*/
		}

		50% {
			transform: scale(1);
		}

		75% {
			transform: scale(1.2);
		}
	}
	
	.scan2 {
		width: 20px;
		height: 20px;
		margin-right: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
		box-shadow: 0 15px 30px rgba(255, 255, 255, .2);
		-webkit-animation-name: scaleDraw;
		/*关键帧名称*/
		-webkit-animation-timing-function: ease-in-out;
		/*动画的速度曲线*/
		-webkit-animation-iteration-count: infinite;
		/*动画播放的次数*/
		-webkit-animation-duration: 4s;
		/*动画所花费的时间*/
	}
	
	
</style>
